<template>
  <customdialog
    v-model="dialog"
    max-width="450px"
    title="Fatura Bilgileri Düzenleme"
    :cardtextstyle="'height: 600px;'"
  >
    <div>
      <v-tabs slot="extension" v-model="active">
        <v-tab :href="`#0`"> {{ $t('tab_general') }} </v-tab>
        <v-tab :href="`#1`"> {{ $t('E-ARCHIVE') }} </v-tab>
      </v-tabs>
    </div>

    <v-card-text style="height: 850px">
      <v-tabs-items v-model="active">
        <v-tab-item :id="`0`">
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs6 md6 v-if="manuelSeri" sm12>
                  <v-autocomplete
                    maxlength="3"
                    :label="$t('Invoice-Serial')"
                    id="serientervalue"
                    @blur="seriEnter()"
                    @keyup.enter="seriEnter()"
                    :items="itemsfaturaseri"
                    v-model="inputvalue.FaturaSeri"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs6 md6 v-if="!manuelSeri" sm12>
                  <v-select
                    :label="$t('Invoice-Serial')"
                    :items="itemsfaturaseri"
                    v-model="inputvalue.FaturaSeri"
                  >
                  </v-select>
                </v-flex>

                <v-flex xs6 md6 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.FaturaNo"
                    :label="$t('Invoice-No')"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 md6 sm12>
                  <tarihcomp
                    :etiket="$t('Invoice-Date')"
                    :aktifmi="false"
                    :detaygizle="true"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="inputvalue.FaturaTarihi"
                    v-model="inputvalue.FaturaTarihi"
                  >
                  </tarihcomp>
                </v-flex>

                <!-- Vade elle de degistirilebilir; buraya kanca konmadi, yani
                     kullanicinin girdigi deger korunur. -->
                <v-flex xs6 md6 sm12>
                  <tarihcomp
                    :etiket="$t('Maturity-Date')"
                    :aktifmi="false"
                    :detaygizle="true"
                    v-bind:defaultvalue="'no'"
                    v-bind:value="inputvalue.VadeTarihi"
                    v-model="inputvalue.VadeTarihi"
                  >
                  </tarihcomp>

                  <!-- Vade YALNIZCA bu butonla hesaplanir; fatura tarihi
                       degistiginde kendiliginden hesaplanmaz. Buton sadece
                       satis faturasinda gorunur (bkz. satisFaturasiMi). -->
                  <v-btn
                    v-if="satisFaturasiMi"
                    small
                    flat
                    color="primary"
                    class="ma-0 pl-0"
                    :loading="vadeHesaplaniyor"
                    :disabled="vadeHesaplaniyor"
                    @click="VadeyiHesapla()"
                  >
                    <v-icon small class="mr-1">refresh</v-icon>
                    {{ $t('Calculate-Maturity-Date') }}
                  </v-btn>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.Unvan1"
                    :label="$t('Title_label') + '1'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.Unvan2"
                    :label="$t('Title_label') + '2'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.Adres1"
                    :label="$t('Address_label') + '1'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.Adres2"
                    :label="$t('Address_label') + '2'"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.Ilce_Il"
                    :label="$t('District') + '/' + $t('Province')"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.VergiDairesi"
                    :label="$t('Taxcenter_label')"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.VergiNo_TCKimlikNo"
                    :label="$t('Tax-TC-No')"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    v-model="inputvalue.Musteri.EMail"
                    :label="$t('EMail-Mandatory-Electronic-E-Archive-Invoices')"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    maxlength="50"
                    v-model="inputvalue.Musteri.PerFirstName"
                    :label="$t('Name-Mandatory-eInvoice-eArchives-issued-TC')"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-text-field
                    hide-details
                    maxlength="50"
                    v-model="inputvalue.Musteri.PerFamilyName"
                   :label="$t('Surname-Mandatory-for-eInvoice-eArchives-issued-TC')"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>

        <v-tab-item :id="`1`">
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-select
                :items="gonderimSekli"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="EArsiv.gonderimSekli"
                hide-details=""
                item-text="text"
                item-value="value"
                :label="$t('E-archive-Delivery-Method')"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-checkbox
                v-model="internetSatis"
                :label="$t('Internet-Sales')"
                @change="faturaSeriListGetir()"
              ></v-checkbox>
            </v-flex>

            <template v-if="internetSatis">
              <v-flex xs12 sm12 md12>
                <tarihcomp
                  :etiket="$t('E-archive-Payment-Date')"
                  v-bind:defaultvalue="'ok'"
                  v-bind:value="EArsiv.internetSatisBilgi.odemeTarihi"
                  v-model="EArsiv.internetSatisBilgi.odemeTarihi"
                ></tarihcomp>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <webadresicomp
                  v-model="EArsiv.internetSatisBilgi.webAdresiID"
                >
                </webadresicomp>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  :items="odemesekli1"
                  v-model="EArsiv.internetSatisBilgi.odemeSekli"
                  hide-details=""
                  clearable
                  item-text="text"
                  item-value="value"
                  :label="$t('E-archive-Payment-Method')"
                >
                </v-select>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <odemearacicomp
                  :tabdeger="'59'"
                  v-model="EArsiv.internetSatisBilgi.odemeAracisiAdiID"
                >
                </odemearacicomp>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <odemesekillericomp
                  v-model="EArsiv.internetSatisBilgi.odemeSekliDigerAciklamaID"
                >
                </odemesekillericomp>
              </v-flex>
            </template>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yes()">{{
        btnYesCaption
      }}</v-btn>
    </template>

    <template>
      <arksnackbar v-model="status"></arksnackbar>
      <loadingcomp v-model="status.loading"></loadingcomp>
      <hatadialog ref="hatadialog"></hatadialog>

    </template>
  </customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tarihcomp from "@/components/app/customcomp/tarihim";
import odemearacicomp from "@/components/app/bilet/partpage/odemearacicomp.vue";
import odemesekillericomp from "@/components/app/bilet/partpage/odemesekillericomp.vue";
import webadresicomp from "@/components/app/bilet/partpage/webadresicomp.vue";
import tool from "@/components/app/coper/tools";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      status: tool.NewSatatus(),

      btnYesCaption: this.$t('OK'),

      gonderimSekli: [
        {
          text: this.$t('Paper'),
          value: 0,
        },
        {
          text: this.$t('Electronic'),
          value: 1,
        },
      ],

      internetSatis: false,

      odemesekli1: [
        {
          text: this.$t('Credit-Debit-Card'),
          value: 0,
        },
        {
          text: "EFT-" + this.$t('Transfer-v3'),
          value: 1,
        },
        {
          text: this.$t('Cash-on-delivery'),
          value: 2,
        },
        {
          text: this.$t('Payment-Intermediary'),
          value: 3,
        },
        {
          text: this.$t('Other'),
          value: 4,
        },
      ],

      itemsfaturaseri: [],

      active: "0",
      manuelSeri: false,

      inputvalueOrj: null,
      FaturaKesimOzellik:null,

      // Vade hesaplama istegi surerken butonu kilitler; art arda tiklanip
      // birden fazla istek gitmesin.
      vadeHesaplaniyor: false,

      EArsiv: {
        gonderimSekli: 0,
        internetSatisBilgi: {
          odemeAracisiAdiID: null,
          odemeSekli: null,
          odemeSekliDigerAciklamaID: null,
          odemeTarihi: null,
          webAdresiID: null,
        },
      },

      inputvalue: {
        FaturaNo: null,
        FaturaSeri: null,
        FaturaTarihi: null,
        VadeTarihi: null,
        Musteri: {
          Unvan1: null,
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo_TCKimlikNo: null,
          Ilce_Il: null,
          CariKod: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
        },
      },
    };
  },
  components: {
    customdialog,
    tarihcomp,
    odemearacicomp,
    odemesekillericomp,
    webadresicomp,
    arksnackbar,
    loadingcomp,
    hatadialog
  },

  watch: {
    // open() bir Promise donduruyor ama bu Promise yalnizca yes() icinde
    // cozuluyordu. Dialog customdialog'un X simgesiyle kapatildiginda
    // (val=false -> input olayi -> buradaki dialog=false) resolve hic
    // cagrilmiyor ve Promise sonsuza kadar askida kaliyordu. cancel() tam
    // bu isi yapmak icin yazilmis ama hicbir yerden cagrilmiyordu.
    //
    // Su anki dort cagiran da donen Promise'i kullanmiyor, yani gorunur bir
    // arizaya yol acmiyordu; yine de ilk .then() yazan kisiyi bekleyen bir
    // tuzakti. Ayni hata bu projede confirm.vue'de de vardi.
    dialog(yeni) {
      if (yeni === false && this.resolve != null) {
        this.cancel();
      }
    },
  },

  computed: {
    // Bu dialog dort sayfa tarafindan paylasiliyor; vade hesaplama yalnizca
    // SATIS faturasinda anlamli. Ayrim KesimTip ile yapiliyor
    // (bkz. itemsKesimTipi): 1 = Satis, 2 = Komisyon, 3 = Iade,
    // 4 = Makbuz, 5 = Satis E-Fatura.
    //
    // 5 su an hicbir sayfada kullanilmiyor ama adi geregi satis faturasi
    // oldugu icin dahil edildi; ileride kullanilirsa sessizce disarida
    // kalmasin.
    satisFaturasiMi() {
      if (this.FaturaKesimOzellik == null) {
        return false;
      }

      var kesimTip = this.FaturaKesimOzellik.KesimTip;

      return kesimTip === 1 || kesimTip === 5;
    },
  },

  methods: {
    HataYonetimi(response, request, baslik) {
      this.status.loading = false;
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.status.text = "Service Unavailable -" + baslik;
        this.status.show = true;
      }
    },

    // "Vade Tarihi Hesapla" butonu. Hesaplama YALNIZCA bu butonla tetiklenir;
    // fatura tarihi degistiginde kendiliginden calismaz. Vade alanina baska
    // hicbir yerde dokunulmuyor, yani kullanicinin elle girdigi deger
    // butona basilana kadar korunur.
    //
    // O an ekranda duran fatura tarihi kullanilir.
    VadeyiHesapla() {
      var faturaTarihi = this.inputvalue.FaturaTarihi;

      // Vade yalnizca SATIS faturasinda anlamli; komisyon (2), iade (3) ve
      // makbuz (4) icin hesaplanmaz. Bu dialog dort sayfa tarafindan
      // paylasiliyor, kapi bu yuzden burada.
      if (this.satisFaturasiMi != true) {
        return;
      }

      // inputvalue yalnizca baslik alanlarinin kopyasi (bkz. setInputValue);
      // kalemler yalnizca open()'a verilen asil nesnede duruyor.
      var kalemler =
        (this.inputvalueOrj != null && this.inputvalueOrj.Kalemler) || [];

      if (!faturaTarihi || kalemler.length === 0) {
        return;
      }

      // Tek PNR yeterli: vade cari bazinda (CariHesapGenel.VadeGenGun)
      // belirleniyor ve bir fatura tek bir cariye kesiliyor, yani butun
      // kalemler ayni vade gununu paylasiyor.
      let params = {
        PNR_List: [kalemler[0].PNR_No],
        FaturaTarihi: faturaTarihi,
      };

      this.vadeHesaplaniyor = true;

      tool.http_post(this, "VadeTarihiHesapla", params).then(
        (response) => {
          this.vadeHesaplaniyor = false;

          if (response.body.Status != true) {
            this.status.text = (response.body.ErrorList || []).join(" ");
            this.status.show = true;
            return;
          }

          // Uc, iptal edilmis PNR'yi hic dondurmedigi halde Status=true
          // diyebiliyor; data[0] korumasiz okunursa TypeError olurdu.
          var satir = (response.body.data || [])[0];

          if (satir) {
            this.inputvalue.VadeTarihi = satir.VadeTarihi;
          }
        },
        (response) => {
          this.vadeHesaplaniyor = false;
          this.status.text = tool.HataMesajiCoz(response, this.$t.bind(this));
          this.status.show = true;
        }
      );
    },

    seriEnter(v) {
        var indexno = this.itemsfaturaseri.indexOf(document.getElementById('serientervalue').value)
        if (indexno == -1) {
          this.itemsfaturaseri.push(document.getElementById('serientervalue').value)
          this.input.FaturaSeri = document.getElementById('serientervalue').value
        }
      },

    setInputValue(val1, val2) {
      val1.FaturaNo = val2.FaturaNo;
      val1.FaturaSeri = val2.FaturaSeri;
      val1.FaturaTarihi = val2.FaturaTarihi;
      val1.VadeTarihi = val2.VadeTarihi;
      val1.Musteri.Unvan1 = val2.Musteri.Unvan1;
      val1.Musteri.Unvan2 = val2.Musteri.Unvan2;
      val1.Musteri.Adres1 = val2.Musteri.Adres1;
      val1.Musteri.Adres2 = val2.Musteri.Adres2;
      val1.Musteri.VergiDairesi = val2.Musteri.VergiDairesi;
      val1.Musteri.VergiNo_TCKimlikNo = val2.Musteri.VergiNo_TCKimlikNo;
      val1.Musteri.Ilce_Il = val2.Musteri.Ilce_Il;
      val1.Musteri.PerFirstName = val2.Musteri.PerFirstName;
      val1.Musteri.PerFamilyName = val2.Musteri.PerFamilyName;
      val1.Musteri.EMail = val2.Musteri.EMail;
      val1.Musteri.CariKod = val2.Musteri.CariKod;

      val1.EArsiv = JSON.parse(JSON.stringify(val2.EArsiv));
    },

    aktifArsivBilgisi() {
      let r = {
        gonderimSekli: this.EArsiv.gonderimSekli,
        internetSatisBilgi: null,
      };

      if (this.internetSatis) {
        r.internetSatisBilgi = {
          odemeAracisiAdiID: this.EArsiv.odemeAracisiAdiID,
          odemeSekli: this.EArsiv.odemeSekli,
          odemeSekliDigerAciklamaID: this.EArsiv.odemeSekliDigerAciklamaID,
          odemeTarihi: this.EArsiv.odemeTarihi,
          webAdresiID: this.EArsiv.webAdresiID,
        };
      }

      return r;
    },

    faturaSeriListGetir() {
      //this.yenibaslikBilgi.FaturaSeri = null

      let params = null;

      params = {
        CariKod: this.inputvalueOrj.Musteri.CariKod,
        ArsivBilgisi: this.aktifArsivBilgisi(),
        Tip: this.FaturaKesimOzellik.Tip
      };

      if (this.status.loading == false) {
        this.status.loading=true;
        tool.http_post(this, "FaturaSeriList", params).then(
          (response) => {
            this.status.loading=false
            if (response.body.Status == true) {
              if (response.body.data == [] || response.body.data == null) {
                this.manuelSeri = true;
              } else {
                if (
                  response.body.data[0] != null &&
                  response.body.data[0] != ""
                ) {
                  this.manuelSeri = false;
                } else {
                  this.manuelSeri = true;
                }
              }
              this.itemsfaturaseri = response.body.data;
            } else {
              this.status.text = response.body.ErrorList[0];
              this.status.show = true;
              this.manuelSeri = true;
            }
          },
          (response) => {
            this.HataYonetimi(
              response,
              params,
              "Fatura Seri Listesi getirilemedi"
            );
          }
        );
      }
    },

    open(inputvalue,FaturaKesimOzellik) {
      this.active="0";
      this.btnYesCaption = this.$t('OK');
      this.dialog = true;
      this.setInputValue(this.inputvalue, inputvalue);
      this.inputvalueOrj = inputvalue;
      this.FaturaKesimOzellik=FaturaKesimOzellik;
      

      this.EArsiv = {
        gonderimSekli: 0,
        internetSatisBilgi: {
          odemeAracisiAdiID: null,
          odemeSekli: null,
          odemeSekliDigerAciklamaID: null,
          odemeTarihi: null,
          webAdresiID: null,
        },
      };

      

      if (inputvalue.EArsiv != null) {
        this.EArsiv.gonderimSekli = inputvalue.EArsiv.gonderimSekli;

        if (inputvalue.EArsiv.internetSatisBilgi != null) {
          let internet = inputvalue.EArsiv.internetSatisBilgi;

          this.EArsiv.internetSatisBilgi = {
            odemeAracisiAdiID: internet.odemeAracisiAdiID,
            odemeSekli: internet.odemeSekli,
            odemeSekliDigerAciklamaID: internet.odemeSekliDigerAciklamaID,
            odemeTarihi: internet.odemeTarihi,
            webAdresiID: internet.webAdresiID,
          };

          this.internetSatis = true;
        } else {
          this.internetSatis = false;
        }
      }

      this.faturaSeriListGetir();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    yes() {
      this.inputvalue.EArsiv = this.aktifArsivBilgisi();
      this.inputvalue.FaturaKesimOzellik = this.FaturaKesimOzellik;
     
      let params = {
        FaturaTaslak: this.inputvalue,
      };

      tool.http_post(this, "FaturaTaslakValidate", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.setInputValue(this.inputvalueOrj, this.inputvalue);

            // resolve ONCE sifirlanip sonra dialog kapatiliyor: aksi halde
            // dialog=false izleyicisi cancel()'i cagirip ayni Promise'i
            // ikinci kez (bu sefer null ile) cozmeye kalkardi.
            var coz = this.resolve;

            this.resolve = null;
            this.reject = null;
            this.dialog = false;

            if (coz != null) {
              coz(this.inputvalueOrj);
            }
          } else {
            this.status.loading = false;
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        (response) => {
          this.HataYonetimi(
            response,
            params,
            "Taslak doğruluk kontrolü yapılamadı"
          );
        }
      );
    },
    // Dialog kaydedilmeden kapatildiginda cagrilir (bkz. watch: dialog).
    // resolve bir kere cagrilmali; sifirlanmazsa ayni Promise'i ikinci kez
    // cozmeye calisan bir yol acilir.
    cancel() {
      var coz = this.resolve;

      this.resolve = null;
      this.reject = null;
      this.dialog = false;

      if (coz != null) {
        coz(null);
      }
    },
  },
};
</script>
